const conditions = () => {
  return [{ assetClass: { $ne: '' } }, { assetClass: { $ne: 'object.asset-class.options.kapitalgeber' } }]
}

export default conditions
